
import { ISetSkywindAndGreentubeJackpotsAction, TSetJackpotActionPayload, actionTypes } from './types';
import { TJackpots } from 'js/hooks/useGetJackpots/types';

export * from '@core/js/hooks/useGetJackpots/store/actions';

export const setSkywindAndGreentubeJackpot = (payload: TSetJackpotActionPayload): ISetSkywindAndGreentubeJackpotsAction => {
    const { jackpotType } = payload;

    return {
        type: actionTypes.SET_SKYWIND_AND_GREENTUBE,
        payload: jackpotType ? { [jackpotType]: payload[jackpotType], jackpotType } : { jackpots: payload as TJackpots }
    };
};
